import { UnitRateModels } from '@aloft/toolkit-shared';

import { createContext, useContext } from 'react';

export const PropertyGridUnitRateModelsContext = createContext<UnitRateModels | null>(null);

export const usePropertyGridUnitRateModels = () =>
  useContext(PropertyGridUnitRateModelsContext);
